module.exports = __webpack_public_path__ + "img/lasource-7.f0675ae7.jpg";